module.exports = __webpack_public_path__ + "img/web_success_step_02.c3c3aa9c.png";